require('svg4everybody')();

import 'classlist-polyfill';
import 'babel-polyfill';
import 'colcade';
import 'a11y-toggle';
import 'zooming';

// Artery Components
import Accordion from '@vamed/artery/03-components/accordion/accordion.init';
import QualityIndicatorList from '@vamed/artery/03-components/info-boxes/quality-indicator-list/quality-indicator-list.init';
import Carousel from '@vamed/artery/03-components/carousel/carousel.init';
import Gallery from '@vamed/artery/03-components/gallery/gallery.init';
import Panorama from '@vamed/artery/03-components/panorama/panorama-viewer/panorama-viewer.init';
import BatchList from '@vamed/artery/03-components/batch-list/batch-list.init';
import SocialShareLinks from '@vamed/artery/03-components/social-links/social-links.init';
import Notice from '@vamed/artery/03-components/info-boxes/notice/notice.init';
import LanguageNotice from '@vamed/artery/03-components/info-boxes/language-notice/language-notice.init';
import ChainedSelect from '@vamed/artery/03-components/forms/chained-select/chained-select.init';
import Dropdown from '@vamed/artery/03-components/dropdown/dropdown.init';
import Tooltip from '@vamed/artery/03-components/tooltip/tooltip.init';
import VideoContainer from '@vamed/artery/01-basics/video-container/video-container.init';
import limitedJsFunctionality from 'helpers/limitedJs';
import File from '@vamed/artery/01-basics/04-forms/file/file.init';
import BrandHeader from '@vamed/artery/03-components/site-header/brand-header/brand-header.init';
import SiteHeader from '@vamed/artery/03-components/site-header/header/header.init';
import DialogButton from '@vamed/artery/01-basics/01-buttons/dialog-button/dialog-button.init';

// Local Components
import SupplierProfile from '07-microsites/suppliers/supplier-profile/supplier-profile';

// Add tracking call
import Autocomplete from 'autocomplete';

// Add tracking call
import Tracking from 'tracking.init';

// Add class for older browsers (lt-ie10)
if (limitedJsFunctionality) {
  document.documentElement.classList.add('limited-js');
}

// Create global HELIOS namespace
window.HELIOS = Object.assign(
  {
    modules: {}
  },
  window.HELIOS
);

BrandHeader.init('.js-brand-header');
SiteHeader.init('.js-site-header');
Accordion.init('.js-accordion');
QualityIndicatorList.init('.js-quality-indicator-list');
Carousel.init('.js-carousel');
Gallery.init('.js-gallery');
Panorama.init('.js-panorama');
BatchList.init('.js-batch-list');
SocialShareLinks.init('.js-social-share');
Notice.init('.js-notice');
Autocomplete.init('.awesomplete');
ChainedSelect.init('.js-chained-select');
Dropdown.init('.js-dropdown');
Tooltip.init('.js-tooltip');
VideoContainer.init('.js-video');
Tracking.init('[data-tracking-event]');
File.init('.js-file');
SupplierProfile.init('.js-supplier-profile');
DialogButton.init('.js-dialog-button');

window.HELIOS.modules.SiteHeader = SiteHeader;
window.HELIOS.modules.LanguageNotice = LanguageNotice;
